import { render } from "./HistogramChart.vue?vue&type=template&id=7be884ca&scoped=true"
import script from "./HistogramChart.vue?vue&type=script&lang=js"
export * from "./HistogramChart.vue?vue&type=script&lang=js"

import "./HistogramChart.vue?vue&type=style&index=0&id=7be884ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be884ca"]])

export default __exports__